import { aiInRecruitingTransformSectionData } from 'constants/AiInRecruiting'
import type { AiInRecruitingTransformSectionProps } from 'constants/AiInRecruiting'
import styles from './AiInRecruitingTransformSection.module.css'

const AiInRecruitingTransformSection = ({
  title,
  subtitle,
  items,
  cardVariant = 'default',
}: AiInRecruitingTransformSectionProps = {}) => {
  const defaults = aiInRecruitingTransformSectionData
  const sectionTitle = title ?? defaults.title
  const sectionSubtitle = subtitle ?? defaults.subtitle
  const sectionItems = items ?? defaults.items
  const cardClass = cardVariant === 'plain' ? styles.cardPlain : styles.card

  return (
    <section className={styles.transformSection}>
      <div className="container">
        <div className={styles.transformHead}>
          <h2 className={styles.transformTitle}>{sectionTitle}</h2>
          <p className={styles.transformSubtitle}>{sectionSubtitle}</p>
        </div>
        <div className="row g-4">
          {sectionItems.map((item, i) => (
            <div key={i} className="col-12 col-md-6">
              <div className={styles.cardClass}>
                <svg
                  className={styles.cardIcon}
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0001 1.75732C20.7644 1.75732 26.2502 7.24306 26.2502 14.0074C26.2502 20.7717 20.7644 26.2575 14.0001 26.2575C7.23573 26.2575 1.75 20.7717 1.75 14.0074C1.75 7.24306 7.23573 1.75732 14.0001 1.75732ZM11.4562 17.9863L8.45707 14.9847C7.94613 14.4735 7.94602 13.6398 8.45707 13.1286C8.96823 12.6176 9.80564 12.6208 10.3131 13.1286L12.4274 15.2446L17.6873 9.98482C18.1984 9.47366 19.0322 9.47366 19.5433 9.98482C20.0544 10.4959 20.0537 11.3304 19.5433 11.8408L13.3539 18.0301C12.8435 18.5406 12.009 18.5413 11.4979 18.0301C11.4836 18.0158 11.4697 18.0012 11.4562 17.9863Z"
                    fill="#FF952B"
                  />
                </svg>
                <div className={styles.cardContent}>
                  <h3 className={styles.cardTitle}>{item.title}</h3>
                  <p className={styles.cardDesc}>{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default AiInRecruitingTransformSection
